let activeWorkspaceId = null;

export const setActiveWorkspaceId = (id) => {
  activeWorkspaceId = id;
};

export const getActiveWorkspaceId = () => activeWorkspaceId;
